<template>
	<layout-page-v2 class="health-reports" icon="medical doc" :h1="$t('headers.general.medicaldocuments')">
		<div slot="btn-group" class="btn-group">
			<button-icon-text-loading @click.native="openModal({ action: 'add', category_id: selectedId })" icon="plus-w" class="plus btn-add">{{ $t('buttons.actions.add_medicaldocument') }}</button-icon-text-loading>
		</div>
		<div class="side">
			<spinner v-if="categories.loading"/>
			<div v-if="!categories.loading && categoriesFiltered.length" class="side-reports">
				<div class="side-search">
					<input-text v-model="searchString" name="search" placeholder="Search"/>
				</div>
				<router-link
					v-for="category in filteredCategories"
					:key="category.id"
					:to="{ name: 'WatchMedicalDocumentsView', params: { user_uid: user_uid, watch_id: watch_id, category_id: category.id } }"
					class="side-report"
					exact-active-class="side-report-active"
					@click="selected = category">
					<svgicon name="health report" :fill="false" class="icon"/>
					<span>
						<span class="name">{{ $t('categories.report.'+category.name.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) }}</span>
						<span class="count" v-if="category.count">{{ `(${category.count})` }}</span>
					</span>
				</router-link>
				<button v-if="!seeAll" @click="onClickSeeAll" class="btn btn-primary">{{ $t('buttons.general.see_all') }}</button>
			</div>
		</div>
		<div class="main" :class="{ empty: isBaseRoute }">
			<router-view class="medical-documents-container" @delete="getCategories"/>
			<p v-if="isBaseRoute">{{ $t('base.general.please_document') }}</p>
		</div>
		<medical-document-form v-if="modalBox.open" @close="closeModal" :params="modalBox.params" :user_uid="user_uid" :watch_id="watch_id"/>
	</layout-page-v2>
</template>

<script>
import { debounce } from 'debounce'
import Fuse from 'fuse.js'
import MedicalDocument from './MedicalDocument'
import MedicalDocumentForm from './MedicalDocumentForm'
export default {
	components: {
		MedicalDocument,
		MedicalDocumentForm
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			categories: {
				loading: false,
				error: null,
				data: []
			},
			seeAll: false,
			selectedId: null,

			// search
			searchString: '',
			fuseSearchString: '',
			debouncedFilterReports: null,
			// fuse.js options
			options: {
				shouldSort: true,
				threshold: 0.6,
				location: 0,
				distance: 100,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: [
					"name"
				]
			},
			modalBox: {
				open: false,
				params: {}
			}
		}
	},
	computed: {
		categoriesFiltered () {
			return this.categories.data.filter(category => {
				return this.seeAll ? true : category.count > 0
			})
		},
		filteredCategories () {
			//this.$log.info('watch medicaldocuments', 'filteredCategories', this.fuseSearchString)()
			return (this.fuse && this.fuseSearchString) ? this.fuse.search(this.fuseSearchString) : this.categoriesFiltered
		},
		isBaseRoute () {
			return this.$route.name === 'WatchMedicalDocuments'
		}
	},
	watch: {
		'$route' (to, from) {
			this.setSelected()
		},
		searchString () {
			this.debouncedFilterReports()
		},
		categoriesFiltered: {
			handler (value) {
				this.fuse = new Fuse(value, this.options)
			},
			immediate: true
		}
	},
	methods: {
		onClickSeeAll () {
			this.seeAll = !this.seeAll
		},
		setSelected () {
			if (this.$route.params.category_id) {
				this.selectedId = this.$route.params.category_id
			}
		},
		getCategories () {
			this.categories.loading = true
			this.$api.medicaldocuments.categories.getAllWithDocCount(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info('watch medicaldocuments', 'medicaldocuments.getAllWithDocCount OK', response)()
					this.categories.data = response.body.map(category => {
						category.count = parseInt(category.count)
						return category
					})
					//this.fuse = new Fuse(this.categories.data, this.options)
				}).catch(error => {
					this.$log.error('watch medicaldocuments', 'medicaldocuments.getAllWithDocCount ERROR', error)()
					this.categories.error = error
				}).finally(() => {
					this.categories.loading = false
				})
		},
		filterCategories () {
			this.fuseSearchString = this.searchString
		},
		openModal (params = {}) {
			this.modalBox.open = true
			this.modalBox.params = params
		},
		closeModal (params) {
			this.modalBox.open = false
			this.modalBox.params = {}

			if (params.reload) {
				this.setSelected()
				this.getCategories()
				this.$root.$emit('reload-medical-docs')
			}
		}
	},
	beforeCreate () {
		this.$title('Medical Documents')
	},
	created () {
		this.$root.$on('editDocument', this.openModal)
		this.debouncedFilterReports = debounce(this.filterCategories, 200)
		this.setSelected()
		this.getCategories()
	},
	beforeDestroy () {
		this.$root.$off('editDocument', this.openModal)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/medicaldocuments/MedicalDocuments.vue